exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[class*=\" el-icon-lx\"],\r\n[class^=el-icon-lx] {\r\n    font-family: lx-iconfont!important;\r\n}\r\n\r\n[class*=\" el-icon-sort\"],\r\n[class^=el-icon-sort] {\r\n    font-family: el-iconfont!important;\r\n}", ""]);

// exports
